import { render } from "./LinkNotification.vue?vue&type=template&id=44af05c6"
import script from "./LinkNotification.vue?vue&type=script&lang=js"
export * from "./LinkNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__